(function () {
  function initDragScroll() {
    document.querySelectorAll('.review-cards-jdm__grid').forEach(function (scroller) {
      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;

      scroller.addEventListener('pointerdown', function (event) {
        isDown = true;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-dragging');
        scroller.setPointerCapture(event.pointerId);
      });

      scroller.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        scroller.scrollLeft = startScrollLeft - (event.clientX - startX);
      });

      function endDrag() {
        isDown = false;
        scroller.classList.remove('is-dragging');
      }

      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
      scroller.addEventListener('pointerleave', endDrag);
    });
  }

  function initBundleSelector() {
    var selector = document.querySelector('[data-bundle-selector]');
    if (!selector) return;

    var quantityInputId = selector.getAttribute('data-quantity-target');
    var quantityInput = quantityInputId ? document.getElementById(quantityInputId) : null;
    var options = selector.querySelectorAll('.bundle-selector-jdm__option');

    options.forEach(function (option) {
      var radio = option.querySelector('input[type="radio"]');

      option.addEventListener('click', function () {
        options.forEach(function (opt) {
          opt.classList.remove('is-active');
        });
        option.classList.add('is-active');
        radio.checked = true;

        if (quantityInput) {
          quantityInput.value = option.dataset.qty;
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      option.querySelectorAll('.bundle-selector-jdm__swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          var row = swatch.closest('.bundle-selector-jdm__swatches');
          row.querySelectorAll('.bundle-selector-jdm__swatch').forEach(function (s) {
            s.classList.remove('is-selected');
            s.setAttribute('aria-pressed', 'false');
          });
          swatch.classList.add('is-selected');
          swatch.setAttribute('aria-pressed', 'true');

          // The pack's own thumbnail mirrors whichever color "Unidad 1"
          // (or the 1x pack's single color row) has selected — it never
          // touches the native variant field, just its own <img src>.
          if (row && row.dataset.unit === '1') {
            var packPhoto = option.querySelector('[data-pack-photo]');
            var swatchImg = swatch.querySelector('img');
            if (packPhoto && swatchImg) {
              packPhoto.src = swatchImg.src;
              packPhoto.srcset = '';
            }
          }
        });
      });

      option.querySelectorAll('.bundle-selector-jdm__warranty').forEach(function (row) {
        var checkbox = row.querySelector('.bundle-selector-jdm__warranty-input');
        if (!checkbox) return;
        row.addEventListener('click', function (event) {
          if (event.target === checkbox) return;
          checkbox.checked = !checkbox.checked;
        });
      });
    });
  }

  // The pack selector's swatches choose which variant(s) get added to
  // cart, but must never touch the page's own variant-id field — that
  // field is watched by native gallery/media logic that we don't want
  // reacting to a swatch pick. So instead of ever writing to it, every
  // submit from this form is taken over and sent straight to
  // /cart/add.js with the swatch-chosen variant(s), leaving the native
  // field (and anything reading it) exactly as the page loaded it.
  function initBundlePackSubmit() {
    var selector = document.querySelector('[data-bundle-selector]');
    if (!selector) return;

    function selectedVariantId(unitGroup) {
      if (!unitGroup) return null;
      var swatch = unitGroup.querySelector('.bundle-selector-jdm__swatch.is-selected');
      return swatch ? swatch.dataset.variantId : null;
    }

    function submitItems(form, items) {
      var submitButton = form.querySelector('[type="submit"]');
      var spinner = submitButton ? submitButton.querySelector('.loading__spinner') : null;
      if (submitButton) submitButton.setAttribute('aria-disabled', 'true');
      if (spinner) spinner.classList.remove('hidden');

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) {
          return s.id;
        });
        body.sections_url = window.location.pathname;
      }

      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (cart) {
            cart.renderContents(response);
          } else {
            window.location = routes.cart_url;
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          if (submitButton) submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.closest('product-form') || form.closest('.cross-sell-jdm')) return;
        if (!form.querySelector('.product-variant-id')) return;

        var activePack = selector.querySelector('.bundle-selector-jdm__option.is-active');
        if (!activePack) return;

        var unit1 = activePack.querySelector('[data-unit="1"]');
        if (!unit1) return; // no swatches on this product (single variant), let native submit proceed

        var variant1 = selectedVariantId(unit1);
        if (!variant1) return;

        var items = [{ id: variant1, quantity: 1 }];

        if (activePack.dataset.qty === '2') {
          var unit2 = activePack.querySelector('[data-unit="2"]');
          var variant2 = unit2 ? selectedVariantId(unit2) : null;
          if (variant2 && variant2 !== variant1) {
            items.push({ id: variant2, quantity: 1 });
          } else {
            items[0].quantity = 2;
          }
        }

        var warrantyCheckbox = activePack.querySelector('.bundle-selector-jdm__warranty-input');
        if (warrantyCheckbox && warrantyCheckbox.checked && warrantyCheckbox.dataset.warrantyVariantId) {
          items.push({ id: warrantyCheckbox.dataset.warrantyVariantId, quantity: 1 });
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        submitItems(form, items);
      },
      true
    );
  }

  initDragScroll();
  initBundleSelector();
  initBundlePackSubmit();
})();
